import "./styles.scss";

import Popup from "reactjs-popup";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import TimezonePicker from "react-timezone";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import {
  getLevel,
  saveStudent,
  fetchStudents,
  fetchContractsById,
  getGlobalLanguages,
  updateStatusStudentB2B,
} from "../../../store/middleware";
import Plan from "./components/Plan";
import Switch from "./components/Switch";
import Country from "./components/Country";
import ListLanguage from "./components/ListLanguage";
import PhotoAvatar from "../../../components/PhotoAvatar";
import linguitoPNG from "../../../assets/images/icons/linguito.png";
import { setStudent } from "../../../store/slices/b2b/b2bContracts.slice";
import InputForClassTool from "../../../components/elements/NewInputs/InputForClassTool";

import { User } from "../companies/styles";
import { SCButtonAddInput } from "../../../components/Buttons/styles";

function StudentForm(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { setShowAddStudentForm } = props;
  const { user } = useSelector((state) => state.userReducer);
  const { allLingos } = useSelector((state) => state.genericReducer);
  const { contract, student } = useSelector((state) => state.b2bContractsReducer);

  const [generalState, setGeneralState] = useState({
    showDialog2: false,
    showDialog: false,
    alertMessage: "",
    loading: false,
    redirect: false,
    success: false,
    selectedPlan: null,
    plans: [],
    level: "",
  });
  const [isActive, setIsActive] = useState(true);
  const [classTool, setClassTool] = useState(student.classTool ? student.classTool : "");
  const [globallanguages, setGlobalLanguages] = useState([]);
  const [languages, setLanguages] = useState(
    student.studentLanguages.length === 0 ? [{ languageId: 0, isNative: true }] : student.studentLanguages,
  );
  const [userEmails, setUserEmails] = useState(
    student?.userEmails.length === 0 || student?.userEmails.length === 1
      ? [{ email: student.email === "" ? "" : student.email, notify: true }]
      : student?.userEmails,
  );
  const [studentPlanLanguages, setStudentPlanLanguages] = useState([]);
  const [targetClassesPerMonth, setTargetClassesPerMonth] = useState("");
  const [allowBuyExtraClasses, setAllowBuyExtraClasses] = useState("");
  const [allowChangeClassFocus, setAllowChangeClassFocus] = useState(true);
  const [allowChangeLingoPlan, setAllowChangeLingoPlan] = useState("");
  const [observation, setObservation] = useState("");
  const [userPhones, setUserPhones] = useState(
    student?.userPhones.length === 0 ? [{ userPhoneTypeId: "", phone: "" }] : student?.userPhones,
  );
  const [contractPlanId, setContractPlanId] = useState("");
  const [alerttitle, setAlertTitle] = useState("");
  const [openalert, setOpenAlert] = useState(false);
  const [alertdescription, setAlertDescription] = useState("");
  const [bilingueNativo, setBilingueNativo] = useState({ bilingue: false, nativo: true });

  const loadInfos = async () => {
    const plans = await dispatch(fetchContractsById(student.contractId));

    let selectedPlan = [];
    if (student.contractPlanId) {
      selectedPlan = plans?.filter((p) => p.contractPlanId === student.contractPlanId);
      selectedPlan = selectedPlan?.length > 0 ? selectedPlan[0] : [];
      setContractPlanId(student.contractPlanId);
    }
    if (student && student.id !== "") {
      const levels = await dispatch(getLevel(student.id));
      let levelId = 0;
      levels?.map((lvl) => {
        if (lvl.level.id > levelId) {
          levelId = lvl.level.id;
        }
      });
      setGeneralState({ ...generalState, level: levelId });
    }
    setBilingueNativo({
      bilingue: student?.typeLanguage === "bilingual" ? true : false,
      nativo: student?.typeLanguage === "native" ? true : false,
    });

    setGeneralState({ ...generalState, selectedPlan: selectedPlan, plans: plans });

    dispatch(getGlobalLanguages()).then((res) => setGlobalLanguages(res));

    handleStudentPlanLanguages(selectedPlan);

    setIsActive(student?.students?.studentPlans[0]?.active);
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  const handleStudentPlanLanguages = (selectedPlan) => {
    let studentPlanLanguages = [];
    selectedPlan = selectedPlan.length > 0 ? selectedPlan[0] : selectedPlan;

    if (student && student.studentPlanLanguages && student.studentPlanLanguages.length > 0) {
      studentPlanLanguages = student.studentPlanLanguages;
    } else if (selectedPlan && selectedPlan.multiLingo) {
      allLingos.map((l) => {
        studentPlanLanguages.push({
          lingoLanguageId: l.id,
          focus: "business",
          struct: "conversational",
          studentLanguageLevel: 0,
        });
      });
    } else {
      studentPlanLanguages.push({
        lingoLanguageId: "",
        focus: "business",
        struct: "conversational",
        studentLanguageLevel: 0,
      });
    }
    setStudentPlanLanguages(studentPlanLanguages.filter((l) => l.lingoLanguageId !== 101));
  };

  const changeLanguages = (name, value, index) => {
    setStudentPlanLanguages((state) => state.map((item, i) => (i === index ? { ...item, [name]: value } : item)));

    changeItem("studentPlanLanguages", studentPlanLanguages);
  };

  const addPhone = (e) => {
    e.preventDefault();
    setUserPhones((state) => [...state, { userPhoneTypeId: "", phone: "" }]);
  };

  const removePhone = (e, findIndex) => {
    e.preventDefault();
    setUserPhones(userPhones.filter((value, index) => index !== findIndex));
  };

  const handleChangeList = (e, index) => {
    e?.preventDefault();
    e?.persist();

    if (e?.target?.name === "email") {
      setUserEmails((state) =>
        state.map((item, i) => (i === index ? { ...item, email: e.target.value.toLowerCase() } : item)),
      );
    }

    if (e?.target?.name === "notify") {
      setUserEmails((state) => state.map((item, i) => (i === index ? { ...item, notify: e.target.checked } : item)));
    }

    if (e?.target?.name === "phone") {
      setUserPhones((state) =>
        state.map((item, i) => (i === index ? { ...item, [e?.target?.name]: e.target.value } : item)),
      );
      dispatch(
        setStudent({
          ...student,
          userPhones: userPhones,
        }),
      );
    }

    if (e?.target?.name === "userPhoneTypeId") {
      setUserPhones((state) =>
        state.map((item, i) => (i === index ? { ...item, [e?.target?.name]: e.target.value } : item)),
      );
      dispatch(
        setStudent({
          ...student,
          userPhones: userPhones,
        }),
      );
    }

    if (e?.target?.name === "language") {
      setLanguages((state) =>
        state.map((item, i) =>
          i === index ? { ...item, languageId: parseInt(e.target.value), isNative: index === 0 ? true : false } : item,
        ),
      );
    }
  };

  const addEmail = (e) => {
    e.preventDefault();
    setUserEmails((state) => [...state, { email: "", notify: true }]);
  };

  const removeEmail = (e, findIndex) => {
    e.preventDefault();
    setUserEmails(userEmails.filter((value, index) => index !== findIndex));
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    let newObj = { ...student.studentB2b };

    switch (name) {
      case "targetClassesPerMonth":
        setTargetClassesPerMonth(value);
        newObj.targetClassesPerMonth = parseInt(value);
        dispatch(
          setStudent({
            ...student,
            studentB2b: newObj,
          }),
        );
        break;
      case "classTool":
        setClassTool(value);
        changeItem(name, value);
        break;
      case "allowBuyExtraClasses":
        setAllowBuyExtraClasses(value);
        newObj.allowBuyExtraClasses = value;
        dispatch(
          setStudent({
            ...student,
            studentB2b: newObj,
          }),
        );
        break;

      case "allowChangeClassFocus":
        setAllowChangeClassFocus(value);
        newObj.allowChangeClassFocus = value;
        dispatch(
          setStudent({
            ...student,
            studentB2b: newObj,
          }),
        );
        break;
      case "allowChangeLingoPlan":
        setAllowChangeLingoPlan(value);
        newObj.allowChangeLingoPlan = value;
        dispatch(
          setStudent({
            ...student,
            studentB2b: newObj,
          }),
        );
        break;
      case "observation":
        setObservation(value);
        newObj.observation = value;
        dispatch(
          setStudent({
            ...student,
            studentB2b: newObj,
          }),
        );
        break;

      default:
        changeItem(name, value);
        break;
    }
  };

  const handlePlan = async (e) => {
    let { value } = e.target;
    const { plans } = generalState;
    let studentPlanLanguages = [];
    let selectedPlan = plans.filter((p) => p.contractPlanId == value);
    setTargetClassesPerMonth(selectedPlan[0]?.unlimited ? "" : selectedPlan[0].totalClasses);
    if (selectedPlan[0]?.multiLingo) {
      allLingos
        .filter((lang) => lang.active)
        .filter((lang) => lang.id !== 101)
        .map((l) => {
          studentPlanLanguages.push({
            lingoLanguageId: l.id,
            focus: "business",
            struct: "conversational",
            studentLanguageLevel: 0,
          });
        });

      setStudentPlanLanguages(studentPlanLanguages);
    }
    await changeItem("studentPlanLanguages", []);
    setContractPlanId(selectedPlan[0].contractPlanId);
    setGeneralState({ ...generalState, selectedPlan: selectedPlan });
    let newObj = { ...student.studentB2b };
    newObj.targetClassesPerMonth = selectedPlan[0]?.unlimited ? "" : selectedPlan[0].totalClasses;
    dispatch(
      setStudent({
        ...student,
        studentB2b: newObj,
      }),
    );
  };

  const deepChange = ({ original, field, value }) => {
    const keys = field.split(".");
    let obj = { ...original };
    const length = keys.length;

    switch (length) {
      case 1: {
        obj[keys[0]] = value;
        break;
      }

      case 2: {
        obj[keys[0]][keys[1]] = value;
        break;
      }

      case 3: {
        obj[keys[0]][keys[1]][keys[2]] = value;
        break;
      }

      default: {
        return {};
      }
    }
    return obj;
  };

  const changeItem = (name, value) => {
    const newStudent = deepChange({
      original: student,
      field: name,
      value,
    });
    dispatch(setStudent(newStudent));
  };

  const handleBack = () => {
    setShowAddStudentForm(false);
  };

  const prepare = (item) => {
    const student = { ...item };
    delete student.contractId;
    delete student.file;
    delete student.picture;
    student.contractPlanId = parseInt(contractPlanId);
    if (student.id > 0) {
      delete student.levelId;
      delete student.contractPlanId;
    } else {
      delete student.id;
      delete student.studentPlanId;
      delete student.contractStudentId;
      delete student.contractPlanStudent;
    }
    delete student.studentPlanLanguage;
    student.studentPlanLanguages = studentPlanLanguages;

    student.typeLanguage = bilingueNativo.bilingue ? "bilingual" : "native";

    student.userEmails = userEmails;

    student.countryId = parseInt(student.countryId);
    student.userPhones = userPhones.map((i) => {
      return {
        phone: i.phone,
        userPhoneTypeId: parseInt(i.userPhoneTypeId),
      };
    });

    student.studentLanguages = languages.map((i) => {
      return {
        isNative: i.isNative,
        languageId: parseInt(i.languageId),
      };
    });

    return student;
  };

  const emptyFilter = {
    pageNumber: 1,
    pageSize: 100,
    name: "",
    email: "",
    active: "",
    status: "",
  };

  const validateForms = () => {
    if (student.name.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("NAME") }));

      return false;
    } else if (!/^\S+@\S+\.\S+$/.test(student.email) || student.email.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("EMAIL") }));

      return false;
    } else if (student.gender.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("GENDER") }));

      return false;
    } else if (!student.birthDate || moment(student.birthDate) >= moment().add(-1, "hours")) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("BIRTH_DATE") }));

      return false;
    } else if (languages[0].languageId === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("NATIVE_LANGUAGE") }));

      return false;
    } else if (student.countryId <= 0) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("COUNTRY") }));

      return false;
    } else if (student.timezone.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("TIMEZONE") }));

      return false;
    } else if (student.address === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("ADDRESS") }));

      return false;
    } else if (userPhones.length === 0 || userPhones.phone === "" || userPhones.userPhoneTypeId === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("CELLPHONE") }));

      return false;
    } else if (contractPlanId === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("PLANS") }));
    } else if (studentPlanLanguages[0]?.lingoLanguageId === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("LINGO") }));

      return false;
    } else return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForms()) {
      const req = prepare(student);
      try {
        if (!req.birthDate) {
          delete req.birthDate;
        }

        await dispatch(setStudent(req));
        await dispatch(saveStudent(req));

        setGeneralState({
          ...generalState,
          showDialog2: true,
          showDialog: false,
          showAddStudentForm: false,
          redirect: false,
          success: true,
        });
      } catch (err) {
        if (err.response.data && err.response.data.error && err.response.data.error.message) {
          if (err.response.data.error.message.indexOf("The maximum students per plan limit reached") !== -1) {
            setGeneralState({
              ...generalState,
              showDialog2: false,
              showDialog: true,
              alertMessage: t("MAXIMUM_STUDENTS"),
              redirect: false,
              success: false,
            });
          } else {
            setGeneralState({
              ...generalState,
              showDialog2: false,
              showDialog: true,
              alertMessage: err.response.data.error,
              redirect: false,
              success: false,
            });
          }
        } else {
          setGeneralState({
            ...generalState,
            showDialog2: false,
            showDialog: true,
            alertMessage: err.response.data.error,
            redirect: false,
            success: false,
          });
        }
      }
      const filter = {
        ...emptyFilter,
        contractId: contract.id,
      };
      dispatch(fetchStudents(filter));
    }
  };

  const addLanguage = (e) => {
    e.preventDefault();
    setLanguages((state) => [...state, { languageId: 0, isNative: false }]);
  };

  const removeLanguage = (e, findIndex) => {
    e.preventDefault();
    setLanguages(languages.filter((value, index) => index !== findIndex));
  };

  const handleClickBilingueNativo = (e, type) => {
    e.preventDefault();

    if (type === "bilingue") setBilingueNativo({ bilingue: true, nativo: false });
    else setBilingueNativo({ bilingue: false, nativo: true });
  };

  const handleIsActiveStudent = () => {
    const body = {
      studentPlanId: student.studentPlanId,
      status: !isActive,
    };

    dispatch(updateStatusStudentB2B(body))
      .then((res) => res.success && setIsActive((state) => !state))
      .catch((error) => {
        setOpenAlert(true);
        setAlertTitle(t("ERROR"));
        setAlertDescription(error);
      });
  };

  const nativeLanguage = languages?.find((item) => item.isNative);

  const validationLanguageNative = nativeLanguage ? nativeLanguage.languageId : null;

  const { redirect, plans, level, selectedPlan, showDialog2, showDialog, alertMessage } = generalState;

  let dataNew = moment(new Date()).utc().tz(student.timezone);

  moment.utc().tz(student.timezone);

  let dataTimeZone = moment(dataNew).format("LT");

  if (redirect) {
    return <Navigate goBack />;
  }

  return (
    <User>
      <Dialog
        open={showDialog2}
        onClose={() =>
          setGeneralState({
            ...generalState,
            showDialog2: false,
          })
        }
        className="alert-dialog-slide boxModal"
      >
        <DialogTitle className="alert-dialog-slide-title boxModal">
          {!student?.id ? t("STUDENT_MESSAGE_SAVE") : t("STUDENT_MESSAGE_EDIT")}
        </DialogTitle>

        <DialogActions className="alert-dialog-slide-actions boxModal">
          <button type="button" className="btn-back" onClick={handleBack}>
            {"Back"}
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showDialog}
        onClose={() =>
          setGeneralState({
            ...generalState,
            showDialog: false,
          })
        }
        className="alert-dialog-slide boxModal"
      >
        <DialogTitle className="alert-dialog-slide-title boxModal">{t("SOMETHING_WENT_WRONG")}</DialogTitle>
        <DialogContent className="alert-dialog-slide-content boxModal">{t(alertMessage)}</DialogContent>
        <DialogActions className="alert-dialog-slide-actions boxModal">
          <button
            className="new-button close"
            onClick={() =>
              setGeneralState({
                ...generalState,
                showDialog: false,
              })
            }
          >
            {t("OK")}
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openalert}
        className="boxModal"
        onClose={() => setOpenAlert(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <span className="titleModal">{alerttitle}</span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="pass-dialog-description" className="boxModal">
            <span className="formulario">
              <span className="description">{alertdescription}</span>
            </span>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <div className="buttons">
            <button onClick={() => setOpenAlert(false)} color="primary" autoFocus>
              {t("CLOSE")}
            </button>
          </div>
        </DialogActions>
      </Dialog>

      <div className="bigBox bigBoxForm">
        <div className="viewUser">
          <PhotoAvatar
            userID={student.id}
            picture={student.picture}
            setPicture={(e) => dispatch(setStudent({ ...student, picture: e }))}
          />

          <div className="formulario">
            <div className="wrapperBlock">
              <h4 className="textBlock">{t("PERSONAL_DATA")} teste</h4>
            </div>

            <div>
              <div>
                <label>
                  {t("NAME")}
                  <span className="invalid">{t("REQUIRED_FIELD")}</span>
                </label>
              </div>
              <input
                name="name"
                type="text"
                autoComplete="none"
                value={student.name}
                placeholder="Your name"
                className="inputMobile"
                onChange={handleChange}
              />
            </div>

            {userEmails.length &&
              userEmails?.map((item, index) => {
                return (
                  <div key={index}>
                    <div>
                      <label htmlFor={"email" + index}>
                        {index === 0 ? t("EMAIL") : t("EXTRA_EMAIL")}
                        {index === 0 && <span className="invalid">{t("REQUIRED_FIELD")}</span>}
                      </label>
                    </div>
                    <div className="notification">
                      <input
                        required
                        type="text"
                        name="email"
                        value={item.email}
                        autoComplete="none"
                        id={"email" + index}
                        className="newemail inputMobile"
                        placeholder={index === 0 ? t("EMAIL_PLACEHOLDER") : t("EXTRA_EMAIL_PLACEHOLDER")}
                        onChange={(e) => {
                          if (index === 0) handleChange(e);
                          handleChangeList(e, index);
                        }}
                      />
                      <div className="switchBox">
                        <div className="switch__container">
                          <input
                            className="switch switch--shadow"
                            name="notify"
                            id={"notify" + index}
                            type="checkbox"
                            onChange={(e) => handleChangeList(e, index)}
                            checked={item.notify}
                          />
                          <label className="labelNotify" htmlFor={"notify" + index}>
                            <span>{t("NOTIFICATION")}</span>
                            <span className="doubleClick">{t("DOUBLE_CLICK")}</span>
                          </label>
                        </div>
                      </div>
                      {index > 0 ? (
                        <SCButtonAddInput id={index} name="remove" onClick={(e) => removeEmail(e, index)}>
                          {t("DELETE")} <i className="fa fa-times-circle-o fa-lg"></i>
                        </SCButtonAddInput>
                      ) : (
                        <SCButtonAddInput name="addemail" onClick={(e) => addEmail(e)}>
                          {t("ADD_EMAIL")} +
                        </SCButtonAddInput>
                      )}
                    </div>
                  </div>
                );
              })}

            <div className="inputs">
              <div className="lineInputs">
                <div>
                  <label>
                    {t("GENDER")}
                    <span className="invalid">{t("REQUIRED_FIELD")}</span>
                  </label>
                </div>
                <select
                  name="gender"
                  autoComplete="none"
                  value={student.gender}
                  onChange={handleChange}
                  className="input-lingo mediumSelect"
                >
                  <option value="">{t("SELECT")}</option>
                  <option value="notInformed">{t("NOT_INFORMED")}</option>
                  <option value="male">{t("MALE")}</option>
                  <option value="female">{t("FEMALE")}</option>
                </select>
              </div>
              <div className="lineInputs">
                <div>
                  <label>
                    {t("BIRTH_DATE")}
                    <span className="invalid">{t("REQUIRED_FIELD")}</span>
                  </label>
                </div>
                <input
                  type="date"
                  name="birthDate"
                  autoComplete="none"
                  onChange={handleChange}
                  value={student.birthDate}
                  className="input-lingo selectDate"
                />
              </div>
            </div>

            <div className="wrapperBlock">
              <h4 className="textBlock">{t("COUNTRY")}</h4>
            </div>

            <div className="inputs">
              <Country {...props} item={student} handleChange={handleChange} />
            </div>

            <div className="inputs">
              <div className="lineInputs timezoneCard">
                <div>
                  <label>
                    {t("TIMEZONE")}
                    <span className="invalid">{t("REQUIRED_FIELD")}</span>
                  </label>
                </div>
                <TimezonePicker
                  value={student.timezone}
                  onChange={(timezoneName) => {
                    const e = {};
                    e.target = { name: "timezone", value: timezoneName };
                    handleChange(e);
                  }}
                  inputProps={{
                    placeholder: "Select Timezone...",
                    name: "timezone",
                  }}
                />
              </div>
              <div className="lineInputs timezoneCard">
                <p>
                  {t("CURRENT_TIME")}
                  <br /> {t("IN_THIS_TIMEZONE")}: {dataTimeZone}
                </p>
              </div>
            </div>

            <div>
              <div>
                <label>
                  {t("ADDRESS")}
                  <span className="invalid">{t("REQUIRED_FIELD")}</span>
                </label>
              </div>
              <input placeholder="Address" name="address" value={student.address} onChange={handleChange} />
            </div>

            {userPhones.map((item, index) => {
              return (
                <div
                  key={index}
                  className="inputs b2bClassTool telefone testeUserPhones"
                  style={{ flexDirection: "row" }}
                >
                  <div className="lineInputs">
                    <div>
                      <label htmlFor={"phone" + index}>
                        {t("TELEPHONE")}
                        {index === 0 && <span className="invalid">{t("REQUIRED_FIELD")}</span>}
                      </label>
                    </div>
                    <input
                      id={"phone" + index}
                      className="inputMobile"
                      required={index === 0}
                      placeholder={t("PHONE_PLACEHOLDER")}
                      autoComplete="none"
                      name="phone"
                      value={item.phone}
                      onChange={(e) => handleChangeList(e, index)}
                    />
                  </div>
                  <div className="lineInputs">
                    <div>
                      <label htmlFor={"userPhoneTypeId" + index}>
                        {t("TYPE")}
                        <span className="invalid">{t("REQUIRED_FIELD")}</span>
                      </label>
                    </div>
                    <select
                      name="userPhoneTypeId"
                      id={"phoneType" + index}
                      className="inputMobile"
                      autoComplete="none"
                      value={item.userPhoneTypeId}
                      onChange={(e) => handleChangeList(e, index)}
                    >
                      <option value="">{t("SELECT")}</option>
                      <option value="1">{t("COMMERCIAL")}</option>
                      <option value="2">{t("RESIDENCIAL")}</option>
                      <option value="3">{t("CELLPHONE")}</option>
                      <option value="4">{t("WHATSAPP")}</option>
                    </select>
                  </div>
                  {index === 0 && (
                    <div className="lineInputs">
                      <SCButtonAddInput name="addphone" onClick={(e) => addPhone(e)}>
                        {t("BTN_ADD_TEL")} +
                      </SCButtonAddInput>
                    </div>
                  )}
                  {index > 0 && (
                    <SCButtonAddInput id={index} name="remove" onClick={(e) => removePhone(e, index)}>
                      {t("DELETE")} <i className="fa fa-times-circle-o fa-lg"></i>
                    </SCButtonAddInput>
                  )}
                </div>
              );
            })}

            <div className="wrapperBlock">
              <h4 className="textBlock">{t("CLASS_LINK")}</h4>
            </div>

            <div className="inputs b2bClassTool">
              <div className="lineInputs">
                <InputForClassTool
                  name="classTool"
                  data={{ value: classTool, required: false }}
                  inputChange={handleChange}
                  readonly="readonly"
                  tabindex="-1"
                  aria-disabled="true"
                />
              </div>
              <div className="lineInputs">
                <div>
                  <label htmlFor="classToolId">{t("TOOL_ID")}</label>
                </div>
                <input
                  type="text"
                  id="classToolId"
                  name="classToolId"
                  autoComplete="none"
                  value={student.classToolId}
                  onChange={handleChange}
                  placeholder={t("STUDENT_TOOL_ID")}
                />
              </div>
            </div>

            <div>
              <div className="wrapperBlock">
                <h4 className="textBlock">{t("TEACHER")}</h4>
              </div>

              <div className="wrapperSelectTeacher">
                <button
                  onClick={(e) => handleClickBilingueNativo(e, "nativo")}
                  className={`buttonSelectTeacher ${bilingueNativo.nativo && "buttonSelectTeacherActive"}`}
                >
                  {t("NATIVE")}
                </button>
                <button
                  onClick={(e) => handleClickBilingueNativo(e, "bilingue")}
                  className={`buttonSelectTeacher ${bilingueNativo.bilingue && "buttonSelectTeacherActive"}`}
                >
                  {t("BILINGUAL")}
                </button>

                <Popup
                  on={"hover"}
                  position={"right center"}
                  style={{ width: 300, backgroundColor: "red" }}
                  trigger={<img className="linguitoPNG" src={linguitoPNG} />}
                >
                  <div style={{ width: 300 }}>
                    <p style={{ textAlign: "justify", color: "#555D67" }}>{t("MESSAGE_INFO_BILINGUE_NATIVO")}</p>
                  </div>
                </Popup>
              </div>
            </div>

            <div className="wrapperBlock">
              <h4 className="textBlock">{t("LANGUAGE")}</h4>

              <SCButtonAddInput name="addlanguage" onClick={(e) => addLanguage(e)}>
                {t("ADD_LANGUAGE")} +
              </SCButtonAddInput>
            </div>

            <div className="wrapperLanguage">
              <div className="languageMain">
                <div>
                  <label htmlFor="language">
                    {t("NATIVE_LANGUAGE")}
                    <span className="invalid">{t("REQUIRED_FIELD")}</span>
                  </label>
                </div>
                <div className="b2bClassTool">
                  <select
                    name="language"
                    autoComplete="none"
                    className="language b2bClassTool"
                    onChange={(e) => handleChangeList(e, 0)}
                    value={validationLanguageNative ? validationLanguageNative : ""}
                  >
                    <option value="">{t("SELECT")}</option>
                    {globallanguages.map((item) => (
                      <option key={"nativ" + item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {languages?.filter((item) => !item.isNative).length !== 0 && <div className="divSeparation" />}

              <div className="otherLanguage">
                {languages?.filter((item) => !item.isNative).length !== 0 && (
                  <div className="wrapperLabel">
                    <label>{t("OTHER_LANGUAGE")}</label>
                  </div>
                )}

                <div className="wrapperOtherLanguage">
                  {languages
                    ?.filter((item) => !item.isNative)
                    ?.map((item, index) => {
                      if (user?.role !== "student") index = index + 1;
                      return (
                        <div key={index}>
                          <div className="b2bClassTool" style={{ marginTop: -15, display: "flex" }}>
                            <select
                              name="language"
                              autoComplete="none"
                              className="language"
                              id={"language" + index}
                              value={item.languageId}
                              onChange={(e) => handleChangeList(e, index)}
                            >
                              <option value="">{t("SELECT")}</option>
                              {globallanguages.map((item) => (
                                <option key={"gLang" + item.id} value={item.id}>
                                  {item.name}
                                </option>
                              ))}
                            </select>

                            <SCButtonAddInput id={index} name="remove" onClick={(e) => removeLanguage(e, index)}>
                              X
                            </SCButtonAddInput>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>

            <div className="wrapperBlock">
              <h4 className="textBlock">Classes settings</h4>
            </div>

            {plans && <Plan {...props} item={student} plans={plans} onChange={handlePlan} />}

            {level !== "" ? (
              <div className="inputs">
                <div className="inputs lineInputs" style={{ flexDirection: "column" }}>
                  <ListLanguage
                    {...props}
                    selectedPlan={selectedPlan}
                    onChangeLanguages={(o, v, i) => changeLanguages(o, v, i)}
                    studentPlanLanguages={studentPlanLanguages}
                    student={student}
                    level={level}
                    t={t}
                  />
                </div>
              </div>
            ) : (
              <div className="inputs">
                <div className="inputs lineInputs" style={{ flexDirection: "column" }}>
                  <ListLanguage
                    {...props}
                    selectedPlan={selectedPlan}
                    onChangeLanguages={(o, v, i) => changeLanguages(o, v, i)}
                    studentPlanLanguages={studentPlanLanguages}
                    student={student}
                    t={t}
                  />
                </div>
              </div>
            )}

            <div>
              <div>
                <label>{t("TARGET_CLASSES_PER_MONTH")}</label>
              </div>
              <input
                type="text"
                style={{ width: "220px" }}
                value={
                  student.studentB2b.targetClassesPerMonth !== ""
                    ? student.studentB2b.targetClassesPerMonth
                    : targetClassesPerMonth
                }
                name="targetClassesPerMonth"
                onChange={handleChange}
              />
            </div>

            <div>
              <div>
                <label>{t("OBSERVATION")}</label>
              </div>
              <textarea
                name="observation"
                maxLength="2000"
                value={student.studentB2b.observation !== "" ? student.studentB2b.observation : observation}
                onChange={handleChange}
              ></textarea>
            </div>
            <div className="wrapperBlock">
              <h4 className="textBlock">Permissions settings</h4>
            </div>

            <div style={{ paddingBottom: "30px" }}>
              <div>
                <div>
                  <div className="inline-block md">Allow buy extra classes</div>
                  <div className="inline-block">
                    <Switch
                      name="allowBuyExtraClasses"
                      value={
                        student.studentB2b.allowBuyExtraClasses !== false
                          ? student.studentB2b.allowBuyExtraClasses
                          : allowBuyExtraClasses
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div>
                  <div className="inline-block md">Allow change class focus</div>
                  <div className="inline-block">
                    <Switch
                      name="allowChangeClassFocus"
                      value={
                        student.studentB2b.allowChangeClassFocus !== false
                          ? student.studentB2b.allowChangeClassFocus
                          : allowChangeClassFocus
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div>
                  <div className="inline-block md">Allow change course lingo</div>
                  <div className="inline-block">
                    <Switch
                      name="allowChangeLingoPlan"
                      value={
                        student.studentB2b.allowChangeLingoPlan !== false
                          ? student.studentB2b.allowChangeLingoPlan
                          : allowChangeLingoPlan
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            {student.id && (
              <div>
                <div>
                  <label>Status</label>
                </div>
                <Switch
                  name="active"
                  value={isActive}
                  checked="Active"
                  notChecked="Inactive"
                  onChange={handleIsActiveStudent}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="form-buttons">
        <button type="button" className="btn-back" onClick={handleBack}>
          <i className="fa fa-angle-left" aria-hidden="true"></i>
          {t("BTN_BACK")}
        </button>
        <button type="submit" className="btn-save" onClick={handleSubmit}>
          {t("SAVE")}
        </button>
      </div>
    </User>
  );
}

export default StudentForm;
